import { render } from "./FormResult.vue?vue&type=template&id=58a89adb&scoped=true"
import script from "./FormResult.vue?vue&type=script&lang=js"
export * from "./FormResult.vue?vue&type=script&lang=js"

import "./FormResult.vue?vue&type=style&index=0&id=58a89adb&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a89adb"]])

export default __exports__